<h2>{{ 'SAMPLE_DIALOG.OPEN' | translate }}</h2>
<div class="hgap-2">
  <button class="btn primary" (click)="openDialog()">Open sample dialog</button>
  <button class="btn primary" (click)="openDialog(true)">Open sample dialog (small)</button>
</div>
